// /src/common/plugins/snackbar.ts
import { useAppStore } from '@/stores/app'

interface SnackbarOptions {
  text: string
  title?: string
  type?: 'primary' | 'success' | 'warning' | 'error' | 'info'
  timeout?: number
  button?: any
}

export const callSnackbar = (options: SnackbarOptions) => {
  const appStore = useAppStore()
  appStore.addNotification({
    ...options,
    id: Date.now(),
    timestamp: new Date()
  })
}

export default {
  install(app: any) {
    app.config.globalProperties.$snackbar = callSnackbar
    app.provide('snackbar', callSnackbar)
  }
}
